import { Trans } from '@lingui/react'
import { bool, number, string } from 'prop-types'

import Price from 'views/components/atoms/Price'
import { PriceType } from 'views/utils/propTypes'
import { pickRequired } from 'views/utils/propTypeUtils'

const PriceFrom = props => {
  const { label, amount, currency, symbolRight, decimalPlaces } = props

  return (
    <span className="a-Price">
      <Trans
        id={label}
        values={{
          price: (
            <Price
              flat
              amount={amount}
              currency={currency}
              symbolRight={symbolRight}
              decimalPlaces={decimalPlaces}
            />
          ),
        }}
      />
    </span>
  )
}

PriceFrom.propTypes = {
  ...pickRequired(PriceType, ['currency']),
  amount: number,
  symbolRight: bool,
  decimalPlaces: number,
  label: string,
}

PriceFrom.defaultProps = {
  amount: 0,
  currency: 'EUR',
  symbolRight: false,
  decimalPlaces: 2,
  label: /*i18n*/ 'general.label.product.price.from',
}

export default PriceFrom
